import { mileageWithMerchantToken } from '@lib/api/v2';

/**
 * 회원 마일리지 내역 조회
 * @param userId
 * @param startDate
 * @param endDate
 * @param page
 * @returns
 */
export const getMileageUser = (
  userId: number,
  startDate: string,
  endDate: string,
  page: number,
) => {
  return mileageWithMerchantToken.get(`/user/${userId}`, {
    params: {
      startDate,
      endDate,
      page,
    },
  });
};
